import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Provider, connect } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import Landing from './pages/Landing';
import Pricing from './pages/Pricing';
import Privacy from './pages/Privacy';
import About from './pages/About';

import CollectionList from './components/CollectionList';
import Dashboard from './components/Dashboard';
import Signin from './components/Signin';
import Signup from './components/Signup';
import NoAccount from './components/NoAccount';
import NotFound from './components/NotFound';
import UpdatePassword from './components/UpdatePassword';

import './Reset.css';
import './App.css';

import { auth } from './actions';
import Pinstripe from './reducers';

let store = createStore(Pinstripe, applyMiddleware(thunk));

class RootContainerComponent extends Component {
  componentDidMount() {
    this.props.loadUser();
    console.log("isAuthenticated: "+this.props.auth.isAuthenticated);
  }

  MainRoute = ({component: ChildComponent, ...rest}) => {
    return <Route {...rest} render={props => {
      // if (!this.props.auth.isAuthenticated) {
      //   return <CollectionList />
      // } else {
      //   return <ChildComponent {...props} />
      // }
      return <ChildComponent {...props} />
    }} />
  }

  PrivateRoute = ({component: ChildComponent, ...rest}) => {
    return <Route {...rest} render={props => {
      if (this.props.auth.isAuthenticated) {
        return <ChildComponent {...props} />
      } else {
        return <NoAccount />
      }
    }} />
  }

  render() {
    let { PrivateRoute, MainRoute } = this;
    return (
      <div className="App">
        <BrowserRouter>
          <Switch>
            <MainRoute exact path='/' component={Landing} />
            <Route path='/browse' component={CollectionList} />
            <PrivateRoute path='/apps' component={Dashboard} />
            <Route path='/signin' component={Signin} />
            <Route path='/signup' component={Signup} />
            <Route path='/update' component={UpdatePassword} />
            <Route path='/pricing' component={Pricing} />
            <Route path='/privacy' component={Privacy} />
            <Route path='/about' component={About} />
            <Route component={NotFound} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loadUser: () => {
      return dispatch(auth.loadUser());
    }
  }
}

let RootContainer = connect(mapStateToProps, mapDispatchToProps)(RootContainerComponent);

export default class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <RootContainer />
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js